import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppNavigation } from '../../hooks';
import { CONTACT_INFO, BUSINESS_HOURS } from '../../constants';
import { Button } from '../ui';
import './Contact.css';

/**
 * Contact section component
 * Displays contact information and CTAs
 */
const Contact: React.FC = () => {
	const { t } = useTranslation();
	const { goToFreeEstimate, goToBookNow } = useAppNavigation();

	return (
		<section className="contact-section" id="contact">
			<div className="contact-container">
				<div className="contact-header">
					<h2>{t('contact.title')}</h2>
					<p>{t('contact.subtitle')}</p>
				</div>

				<div className="contact-content">
					<div className="contact-info">
						<div className="contact-item">
							<h3>📞 {t('contact.phone')}</h3>
							<p>{CONTACT_INFO.phone}</p>
						</div>

						<div className="contact-item">
							<h3>📧 {t('contact.email')}</h3>
							<p>{CONTACT_INFO.email}</p>
						</div>

						<div className="contact-item">
							<h3>📍 {t('contact.address')}</h3>
							<p>{t('booking.california')}, {t('booking.texas')}, {t('booking.florida')}</p>
						</div>

						<div className="contact-item">
							<h3>⏰ {t('contact.hours')}</h3>
							<p>{t('timeSlot.afternoon', 'Afternoon')}: {BUSINESS_HOURS.afternoon}</p>
							<p>{t('timeSlot.evening', 'Evening')}: {BUSINESS_HOURS.evening}</p>
							<p>{t('timeSlot.night', 'Night')}: {BUSINESS_HOURS.night}</p>
						</div>
					</div>

					<div className="contact-cta">
						<h3>{t('booking.title')}</h3>
						<div className="cta-buttons">
							<Button variant="secondary" onClick={goToFreeEstimate}>
								{t('nav.freeEstimate')}
							</Button>
							<Button variant="primary" onClick={goToBookNow}>
								{t('nav.bookNow')}
							</Button>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Contact;
